import { FaDumbbell, FaUsers, FaFemale, FaAppleAlt, FaCode, FaMoneyBill, FaShieldAlt, FaUserTie, FaBullhorn, FaBriefcase } from "react-icons/fa";

const topics = [
  { icon: <FaDumbbell />, title: "Athletic Measurement Testing" },
  { icon: <FaUsers />, title: "Youth Empowerment Summits" },
  { icon: <FaFemale />, title: "Women Empowerment Conferences" },
  { icon: <FaAppleAlt />, title: "Nutrition Health Wellness" },
  { icon: <FaCode />, title: "Tech & Coding" },
  { icon: <FaMoneyBill />, title: "Financial Literacy" },
  { icon: <FaShieldAlt />, title: "Gun Violence Prevention" },
  { icon: <FaUserTie />, title: "Gang Prevention" },
  { icon: <FaBullhorn />, title: "Marketing" },
  { icon: <FaBriefcase />, title: "Life Skills & Career Building" },
];

export default function BusinessLeadershipPage() {
  return (
    <div className="min-h-screen dark:bg-gradient-to-r from-black to-stone-700 flex flex-col items-center lg:pt-20 p-8 pb-0">
      <h1 className="text-4xl font-bold text-black dark:text-white mb-6 text-center">
      Specializing in:
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-4xl">
        {topics.map((topic, index) => (
          <div
            key={index}
            className="flex items-center p-4 dark:bg-[#333] bg-white shadow-lg rounded-2xl transition-transform transform hover:scale-105"
          >
            <div className="text-3xl text-red-600 mr-4">{topic.icon}</div>
            <h2 className="text-lg font-semibold text-gray-700 dark:text-white">{topic.title}</h2>
          </div>
        ))}
      </div>
    </div>
  );
}
